import axios from "axios";
import { assessment_base_ml_url } from "./base_urls";

export const AI_CREATE_SESSION_URL = `${assessment_base_ml_url}create-session`;
export const AI_CHAT_URL = `${assessment_base_ml_url}chat-stream`;
export const AI_EXAM_URL = `${assessment_base_ml_url}exam`;
// Ensure axios has sane defaults for this service
axios.defaults.headers.post["Content-Type"] = "application/json";
